module.exports = __webpack_public_path__ + "img/heihucode.fb67a0c3.jpg";